import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "label-config",
    templateUrl: "./label-config.view.html",
    providers: []
})
export class LabelConfigView implements OnInit {
    baseUrl = "";
    labelConfig: any = {};
    searchBarConfig: any = {};
    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        this.baseUrl = sharedService.sessionUrl;
        if (this.activatedRoute.parent.routeConfig.path == "speaker-sessions") {
            this.labelConfig = this.sharedService.sessionLayoutConfig.labelConfig;
        } else if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.labelConfig = this.sharedService.speakerLayoutConfig[this.baseUrl].labelConfig;
            this.searchBarConfig = this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig;
        }
    }

    ngOnInit() {}
}
